<template>
    <input
            ref="inputRef"
            :type="props.type"
            :class="props.inputClass"
            :name="props.name"
            :placeholder="props.placeholder"
            :value="modelValue"
            @input="changeInput($event.target.value)"
            @keyup="$emit('keyup', $event)"
    />
</template>

<script setup>

import {ref, onMounted} from 'vue';

const props = defineProps({
    type: {
        type: String,
        default: 'text'
    },
    inputClass: {
        type: String,
        default: 'input'
    },
    placeholder: {
        type: String,
        default: ''
    },
    name: {
        type: String,
        default: ''
    },
    modelValue: {
        type: [String, Number],
        default: ''
    }
})

const emit = defineEmits(['update:modelValue', 'keyup'])
const changeInput = (value) => {
    emit('update:modelValue', value);
}

</script>
  